import OBase from './OBase';

import * as Geometry from '../geometry';

export default class ListLength extends OBase {
  update () {
    let lInputTree = this.getObjectInput('List');
    let lOutput = this.getGenericObjectOutput('Length');

    var outTree = new Geometry.DataTree();

    for (let i = 0; i < lInputTree.branches.length; i++) {
      let count = lInputTree.branches[i].length;
      outTree.add(count, lInputTree.paths[i]);
    }

    lOutput.value = outTree;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/ListLength.js